<template>
  <div ref="pageView" class="page-view container-view">
    <div class="DetailsInfo" v-loading="loading">
      <!-- title -->
      <section class="DetailsInfo-title">
        <template v-if="taskType === 10">
          <e6-title>入库预约 </e6-title>
        </template>
        <template v-else-if="taskType === 20">
          <e6-title>
            提货出库
          </e6-title>
        </template>
      </section>
      <!-- title end -->

      <!-- content -->
      <div class="DetailsInfo-content">
        <!-- 单号显示 -->
        <section class="module-orderTitle" v-if="taskType === 10">
          <span class="orderWord">预约单号：</span>
          <span class="orderNum">{{ orderNumber.appiontOrder }}</span>
        </section>
        <section class="module-orderTitle" v-else-if="taskType === 20">
          <span class="orderWord">预约单号：</span>
          <span class="orderNum">{{ orderNumber.appiontOrder }}</span>
        </section>
        <!-- 商品基础信息 -->
        <section class="module-Info" v-if="taskType === 10">
          <div class="module-title">商品基础信息</div>
          <div class="module-content">
            <!-- 入库预约 -->
            <template>
              <el-table
                :data="goodsInfoData"
                :border="true"
                style="width: 100%"
                class="module-table"
                max-height="215px"
              >
                <template v-for="(col, index) in goodsInfoColumn">
                  <el-table-column
                    v-if="col.mode !== 'pickOwn'"
                    :key="index"
                    :label="col.label"
                    :prop="col.prop"
                    :resizable="col.resizable"
                    :align="col.align"
                    :header-align="col['header-align']"
                    :min-width="col['min-width']"
                  ></el-table-column>
                </template>
              </el-table>
            </template>
          </div>
        </section>
        <!-- 商品入境信息 -->
        <section class="module-Info" v-if="taskType === 10">
          <div class="module-title">商品入境信息</div>
          <div class="module-content">
            <!-- 入库预约 -->
            <template>
              <el-table
                :data="goodsInfoData"
                :border="true"
                style="width: 100%"
                class="module-table"
                max-height="215px"
              >
                <template v-for="(col, index) in goodsEnterColumn">
                  <el-table-column
                    :key="index"
                    :label="col.label"
                    :prop="col.prop"
                    :resizable="col.resizable"
                    :align="col.align"
                    :header-align="col['header-align']"
                    :min-width="col['min-width']"
                  >
                    <template slot-scope="scope">
                      <template v-if="col.prop === 'quarantinePhoto'">
                        <e6-image-viewer
                          v-show="showViewers.quarantineShow"
                          :on-close="closeViewer"
                          :url-list="scope.row.quarantinePhoto"
                        >
                        </e6-image-viewer>
                        <el-link
                          class="module-link"
                          :underline="false"
                          @click="handleToggle('quarantineShow')"
                        >
                          查看图片
                        </el-link>
                      </template>
                      <template v-else-if="col.prop === 'customsDecPhoto'">
                        <e6-image-viewer
                          v-show="showViewers.declareShow"
                          :on-close="closeViewer"
                          :url-list="scope.row.customsDecPhoto"
                        >
                        </e6-image-viewer>
                        <el-link
                          class="module-link"
                          :underline="false"
                          @click="handleToggle('declareShow')"
                        >
                          查看图片
                        </el-link>
                      </template>
                      <template v-else>
                        <div>{{ scope.row[col.prop] }}</div>
                      </template>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </template>
          </div>
        </section>
        <!-- 提货预约信息 -->
        <section class="module-Info" v-if="taskType === 20">
          <template>
            <div class="module-specialTitle">
              <div class="module-inlineTitle">商品信息</div>
              <div class="button-location">
                <!-- <template>
                  <e6-image-viewer
                    v-show="showViewers.storePageShow"
                    :on-close="closeViewer"
                    :url-list="item.warehouseReceiptPhoto"
                  >
                  </e6-image-viewer>
                  <el-button
                    class="module-button"
                    @click="handleToggle('storePageShow')"
                  >
                    仓单图片
                  </el-button>
                </template>
                <template>
                  <e6-image-viewer
                    v-show="showViewers.goodsPhotoShow"
                    :on-close="closeViewer"
                    :url-list="item.pickUpFrontphoto"
                  >
                  </e6-image-viewer>
                  <el-button
                    class="module-button"
                    @click="handleToggle('goodsPhotoShow')"
                  >
                    提货证明照片
                  </el-button>
                </template> -->
              </div>
            </div>
            <div class="module-content">
              <template>
                <div class="module-content">
                  <!-- 出库预约 -->
                  <template>
                    <el-table
                      :data="pickInfo"
                      :border="true"
                      style="width: 100%"
                      class="module-table"
                      max-height="215px"
                    >
                      <template v-for="(col, index) in goodsInfoColumn">
                        <el-table-column
                          v-if="col.mode === 'pick' || col.mode === 'pickOwn'"
                          :key="index"
                          :label="col.label"
                          :prop="col.prop"
                          :resizable="col.resizable"
                          :align="col.align"
                          :header-align="col['header-align']"
                          :min-width="col['min-width']"
                        ></el-table-column>
                      </template>
                      <el-table-column
                        label="仓单图片"
                        :resizable="true"
                        align="center"
                        header-align="center"
                        :min-width="100"
                      >
                        <template slot-scope="{ row }">
                          <e6-image-viewer
                            v-show="showViewers.storePageShow"
                            :on-close="closeViewer"
                            :url-list="row.warehouseReceiptPhoto"
                          >
                          </e6-image-viewer>
                          <el-link
                            class="module-link"
                            @click="handleToggle('storePageShow')"
                          >
                            查看图片
                          </el-link>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="提货证明照片"
                        :resizable="true"
                        align="center"
                        header-align="center"
                        :min-width="100"
                      >
                        <template slot-scope="{ row }">
                          <e6-image-viewer
                            v-show="showViewers.goodsPhotoShow"
                            :on-close="closeViewer"
                            :url-list="row.pickUpFrontphoto"
                          >
                          </e6-image-viewer>
                          <el-link
                            class="module-link"
                            @click="handleToggle('storePageShow')"
                          >
                            查看图片
                          </el-link>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </div>
              </template>
            </div>
          </template>
        </section>
        <!-- 预约信息 -->
        <section class="module-Info">
          <div class="module-specialTitle">
            <div class="module-inlineTitle">
              预约信息
            </div>
            <div class="code">
              <template v-if="taskType === 10">
                <span class="codeWord">预约码:</span>
                <span class="codeNum">{{ appiontInfo.code }}</span>
              </template>
              <template v-else-if="taskType === 20">
                <span class="codeWord">提货码:</span>
                <span class="codeNum">{{ appiontInfo.code }}</span>
              </template>
            </div>
          </div>
          <div class="module-content">
            <el-form :inline="true" label-width="110px" label-position="right">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="仓库名称">{{
                    appiontInfo.warehouseName
                  }}</el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="预约时间">{{
                    appiontInfo.reserveTime
                  }}</el-form-item></el-col
                >
                <el-col :span="8">
                  <el-form-item label="预约状态">{{
                    appiontInfo.reserveStatus
                  }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="仓库联系人">{{
                    appiontInfo.warehousePerson
                  }}</el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="仓库联系电话">{{
                    appiontInfo.warehousePhone
                  }}</el-form-item></el-col
                >
                <el-col :span="8">
                  <el-form-item label="仓库地址">{{
                    appiontInfo.warehouseAddress
                  }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="预约单位名称">{{
                    appiontInfo.reserveCorpName
                  }}</el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="预约单位联系人">{{
                    appiontInfo.reservePerson
                  }}</el-form-item></el-col
                >
                <el-col :span="8">
                  <el-form-item label="预约单位电话">{{
                    appiontInfo.reserveCorpPhone
                  }}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="预约单位地址">{{
                    appiontInfo.reserveAddress
                  }}</el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </section>
        <!-- 运输信息 -->
        <section class="module-Info">
          <div class="module-title">运输信息</div>
          <template>
            <div class="module-content">
              <el-form
                :inline="true"
                label-width="110px"
                label-position="right"
              >
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="运输车辆">{{
                      transportInfo.vehiclesNum
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="运输司机">{{
                      transportInfo.driverName
                    }}</el-form-item></el-col
                  >
                  <el-col :span="8">
                    <el-form-item label="司机联系方式">{{
                      transportInfo.driverPhone
                    }}</el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </template>
          <!-- 入库预约专有 -->
        </section>

        <!-- 以下入库预约独有的两个模块 -->
        <!-- 消毒记录 -->
        <section class="module-Info" v-if="taskType === 10">
          <div class="module-title">消毒记录</div>
          <template>
            <el-table
              :data="disinfectTableData"
              :border="true"
              style="width: 100%"
              max-height="215px"
            >
              <template v-for="(col, index) in disinfectColumn">
                <el-table-column
                  :key="index"
                  :label="col.label"
                  :prop="col.prop"
                  :resizable="col.resizable"
                  :align="col.align"
                  :header-align="col['header-align']"
                  :min-width="col['min-width']"
                >
                  <template slot-scope="scope">
                    <template v-if="col.prop === 'disPhoto'">
                      <e6-image-viewer
                        v-show="showViewers.disinfectShow"
                        :on-close="closeViewer"
                        :url-list="scope.row.disPhoto"
                      >
                      </e6-image-viewer>
                      <el-link
                        :underline="false"
                        class="module-link"
                        @click="handleToggle('disinfectShow')"
                      >
                        查看图片
                      </el-link>
                    </template>
                    <template v-else>
                      <div>{{ scope.row[col.prop] }}</div>
                    </template>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </template>
        </section>
        <!-- 核酸检测记录 -->
        <section class="module-Info" v-if="taskType === 10">
          <div class="module-title">核酸检测记录</div>
          <template>
            <el-table
              :data="nadTableData"
              :border="true"
              style="width: 100%"
              max-height="215px"
            >
              <template v-for="(col, index) in nadTableColumn">
                <el-table-column
                  :key="index"
                  :label="col.label"
                  :prop="col.prop"
                  :resizable="col.resizable"
                  :align="col.align"
                  :header-align="col['header-align']"
                  :min-width="col['min-width']"
                >
                  <template slot-scope="scope">
                    <template v-if="col.prop === 'testReportsPhoto'">
                      <e6-image-viewer
                        v-show="showViewers.nadShow"
                        :on-close="closeViewer"
                        :url-list="scope.row.testReportsPhoto"
                      >
                      </e6-image-viewer>
                      <el-link
                        :underline="false"
                        class="module-link"
                        @click="handleToggle('nadShow')"
                      >
                        查看图片
                      </el-link>
                    </template>
                    <template v-else>
                      <div>{{ scope.row[col.prop] }}</div>
                    </template>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </template>
        </section>
      </div>
      <!-- content end -->
    </div>
    <div class="footer">
      <el-button type="info" plain @click="$router.push('/storageMonitor')"
        >返 回</el-button
      >
    </div>
  </div>
</template>
<script>
import resizeListener from "_private/mixins/resizeListener";
import { fetchGoodsInfo } from "@/api/Details";
export default {
  mixins: [resizeListener],
  data() {
    return {
      loading: "",
      taskType: "", //用作入库预约和提货预约页面显示的判断 10:入库预约 20：提货预约
      curImg: "", //用来保存当前打开的imageview对象
      //订单号
      orderNumber: {
        // 预约单号
        appiontOrder: ""
      },
      //控制图片隐藏显示
      showViewers: {
        //仓单showViewer
        storePageShow: false,
        //提货照片showViewer
        goodsPhotoShow: false,
        //检疫单号
        quarantineShow: false,
        //报关单号
        declareShow: false,
        //消毒记录
        disinfectShow: false,
        //核酸检测记录
        nadShow: false
      },
      // 提货商品信息模块数据
      // pickInfo: {
      //   // 名称
      //   productName: "",
      //   // 单位
      //   unit: "",
      //   // 库存数量
      //   stocksCount: "",
      //   // 提货数量
      //   pickUpCount: "",
      //   // 毛重
      //   pickUpGrossWeight: "",
      //   // 净重
      //   pickUpNetWeight: "",
      //   // 仓单图片
      //   warehouseReceiptPhoto: [],
      //   // 提货证明照片
      //   pickUpFrontphoto: []
      // },
      pickInfo: [],
      //预约信息模块数据
      appiontInfo: {
        // 仓库名称
        warehouseName: "",
        //预约时间
        reserveTime: "",
        //预约状态
        reserveStatus: "",
        //仓库联系人
        warehousePerson: "",
        //仓库联系电话
        warehousePhone: "",
        //仓库地址
        warehouseAddress: "",
        //预约/提货码
        code: "",
        //预约单位名称
        reserveCorpName: "",
        //预约单位联系人
        reservePerson: "",
        //预约单位电话
        reserveCorpPhone: "",
        //预约单位地址
        reserveAddress: ""
      },
      //运输信息模块数据
      transportInfo: {
        //运输车辆
        vehiclesNum: "",
        //运输司机
        driverName: "",
        //司机联系方式
        driverPhone: ""
      },
      //消毒记录表格列
      disinfectColumn: [
        {
          label: "消毒产品数量",
          prop: "disProductNum",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "消毒日期",
          prop: "disTimeStr",
          "min-width": 140,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "消毒人员",
          prop: "disPerson",
          "min-width": 80,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "消毒地点",
          prop: "disAddress",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "消毒对象",
          prop: "disObj",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "消毒方法",
          prop: "disMethod",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "使用消毒设备",
          prop: "useDisEquipment",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "消毒设备备案号",
          prop: "disFilingNum",
          "min-width": 120,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "消毒设备作用时间",
          prop: "useDisEquipmentTime",
          "min-width": 140,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "消毒设备紫外光照度",
          prop: "uvLightLevel",
          "min-width": 140,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "消毒剂厂家名称",
          prop: "disFactoryName",
          "min-width": 120,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "消毒产品备案号",
          prop: "disProductFilingNum",
          "min-width": 120,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "消毒剂用量浓度",
          prop: "disUseConcentration",
          "min-width": 140,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "消毒作用时间",
          prop: "disUseTime",
          "min-width": 140,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "消毒报告照片",
          prop: "disPhoto",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        }
      ],
      //商品信息表格列
      goodsInfoColumn: [
        {
          label: "提货仓单号",
          prop: "pickUpOrder",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center",
          mode: "pickOwn"
        },
        {
          label: "商品名称",
          prop: "productName",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center",
          mode: "pick"
        },
        {
          label: "规格/型号",
          prop: "specification",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "单位",
          prop: "unit",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center",
          mode: "pick"
        },
        {
          label: "库存数量",
          prop: "stocksCount",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center",
          mode: "pickOwn"
        },
        {
          label: "提货数量",
          prop: "pickUpCount",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center",
          mode: "pickOwn"
        },
        {
          label: "产品批次",
          prop: "productBatch",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "生产日期",
          prop: "createdTime",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "保质期",
          prop: "shelfLife",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "数量",
          prop: "num",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "毛重",
          prop: "grossWeight",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "净重",
          prop: "netWeight",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "提货毛重",
          prop: "pickUpGrossWeight",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center",
          mode: "pickOwn"
        },
        {
          label: "提货净重",
          prop: "pickUpNetWeight",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center",
          mode: "pickOwn"
        }
      ],
      //商品入境信息表格列
      goodsEnterColumn: [
        {
          label: "商品名称",
          prop: "productName",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "入境口岸",
          prop: "portsOfEntry",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "入境日期",
          prop: "dateOfEntry",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "到货日期",
          prop: "arrivalDate",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "原产国",
          prop: "originalCountry",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "集装箱号",
          prop: "containerShip",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "铅封号",
          prop: "sealNum",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "检疫单号",
          prop: "quarantineBillNum",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "检疫单照片",
          prop: "quarantinePhoto",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "报关单号",
          prop: "customsDecNum",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "海关单照片",
          prop: "customsDecPhoto",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        }
      ],
      //核酸检测记录表格列：
      nadTableColumn: [
        {
          label: "商品名称",
          prop: "productName",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "外箱样品编号",
          prop: "outerBoxNum",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "外箱箱数",
          prop: "outerBoxCount",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "外包装样品编号",
          prop: "outerPacking",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "外包装箱数",
          prop: "outPackingCount",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "内容物样品编号",
          prop: "boxContents",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "内容物箱数",
          prop: "boxContentsCount",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        },
        {
          label: "检测报告照片",
          prop: "testReportsPhoto",
          "min-width": 100,
          resizable: true,
          align: "center",
          "header-align": "center"
        }
      ],
      //商品信息表格数据
      goodsInfoData: [],
      //消毒记录表格数据
      disinfectTableData: [],
      //核酸检测表格数据
      nadTableData: [],
      primaryKeyId: ""
    };
  },
  created() {
    this.taskType = parseInt(this.$route.query.taskType);
    this.primaryKeyId = this.$route.query.primaryKeyId;
    this.orderNumber.appiontOrder = this.$route.query.orderNum;
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    //获取页面数据
    async getPageData() {
      try {
        let obj = {
          reserveType: this.taskType,
          orderNum: this.orderNumber.appiontOrder,
          primaryKeyId: this.primaryKeyId
        };
        this.loading = true;
        let [tem] = await Promise.all([fetchGoodsInfo(obj)]);
        console.log(tem);
        // this.orderNumber = tem.result.orderNumber;
        if (this.taskType === 10) {
          if (tem.result.productMessageVOList.length > 0) {
            this.goodsInfoData = tem.result.productMessageVOList;
            for (let i = 0; i < this.goodsInfoData.length; i++) {
              if (
                this.goodsInfoData[i].quarantinePhoto &&
                this.goodsInfoData[i].quarantinePhoto !== ""
              ) {
                this.goodsInfoData[i].quarantinePhoto = this.goodsInfoData[
                  i
                ].quarantinePhoto.split(",");
              }
              if (
                this.goodsInfoData[i].customsDecPhoto &&
                this.goodsInfoData[i].customsDecPhoto !== ""
              ) {
                this.goodsInfoData[i].customsDecPhoto = this.goodsInfoData[
                  i
                ].customsDecPhoto.split(",");
              }
            }
          }
          if (tem.result.disRecordVOS.length > 0) {
            this.disinfectTableData = tem.result.disRecordVOS;
            for (let i = 0; i < this.disinfectTableData.length; i++) {
              if (
                this.disinfectTableData[i].disPhoto &&
                this.disinfectTableData[i].disPhoto !== ""
              ) {
                this.disinfectTableData[i].disPhoto = this.disinfectTableData[
                  i
                ].disPhoto.split(",");
              }
            }
          }
          if (tem.result.testRecordVOS.length > 0) {
            this.nadTableData = tem.result.testRecordVOS;
            for (let i = 0; i < this.nadTableData.length; i++) {
              if (
                this.nadTableData[i].testReportsPhoto &&
                this.nadTableData[i].testReportsPhoto !== ""
              ) {
                this.nadTableData[i].testReportsPhoto = this.nadTableData[
                  i
                ].testReportsPhoto.split(",");
              }
            }
          }
        } else if (this.taskType === 20) {
          if (tem.result.productMessageOutVO) {
            this.pickInfo = tem.result.productMessageOutVO;

            for (let i = 0; i < this.pickInfo.length; i++) {
              if (
                this.pickInfo[i].warehouseReceiptPhoto &&
                this.pickInfo[i].warehouseReceiptPhoto !== ""
              ) {
                this.pickInfo[i].warehouseReceiptPhoto = this.pickInfo[
                  i
                ].warehouseReceiptPhoto.split(",");
              }
              if (
                this.pickInfo[i].pickUpFrontphoto &&
                this.pickInfo[i].pickUpFrontphoto !== ""
              ) {
                this.pickInfo[i].pickUpFrontphoto = this.pickInfo[
                  i
                ].pickUpFrontphoto.split(",");
              }
            }
          }
        }
        if (tem.result.warehouseReservationVO) {
          this.appiontInfo = tem.result.warehouseReservationVO;
          this.transportInfo = tem.result.warehouseReservationVO;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    //图片按钮的相关事件
    handleToggle(type) {
      this.showViewers[type] = !this.showViewers[type];
      this.curImg = type;
    },
    closeViewer() {
      this.showViewers[this.curImg] = false;
      this.curImg = "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/DetailsInfo.scss";
</style>
